import { render } from "./OrdinaryButton.vue?vue&type=template&id=4cc8908e&scoped=true"
import script from "./OrdinaryButton.vue?vue&type=script&lang=js"
export * from "./OrdinaryButton.vue?vue&type=script&lang=js"

import "./OrdinaryButton.vue?vue&type=style&index=0&id=4cc8908e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4cc8908e"

export default script